import React, {useState, useEffect} from 'react';
import OtpInput from 'react-otp-input';


export function TotpInput({ signature, trigger }) {

  const [codeOtp, setCodeOTP] = useState('');
  const handleChange = (otp) => { setCodeOTP(otp); };
  const styleLogin = {
    width: '2rem',
    height: '3rem',
    margin: '0 1rem',
    fontSize: '2rem',
    borderRadius: '4px',
    border: '2px solid rgba(0,0,0,.5)'
  };
  const styleSignature = {
    width: '3rem',
    height: '3rem',
    margin: '0 1rem',
    fontSize: '2rem',
    borderRadius: '4px',
    border: '2px solid rgba(0,0,0,.5)'
  };

  useEffect(() => {
    if (codeOtp.length === 6){
      trigger(codeOtp);
    }
  }, [codeOtp]);

  return (
    <OtpInput
      inputStyle={signature ? styleSignature : styleLogin}
      isInputNum
      value={codeOtp}
      onChange={handleChange}
      numInputs={6}
      // renderSeparator={}
      renderInput={(props) => <input {...props} />}
      shouldAutoFocus
    />
  );
}